import { useGetReviewerPermissions } from '@exam-center/admin-proctor-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Navigate } from '@exam-center/router';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

export default function AdminExamProctorManagementPage() {
  const { permissions } = usePermission();
  const { view } = useGetReviewerPermissions();

  const initialTab = useMemo(() => {
    if (permissions.includes(APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.VIEW)) {
      return 'proctors';
    }

    if (view.supervisor || view.firstTierReviewer || view.secondTierReviewer) {
      return 'requests';
    }

    if (permissions.includes(APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.AUDIT_LOG.VIEW)) {
      return 'activity-log';
    }
    return null;
  }, [permissions, view]);

  if (!initialTab) {
    return <Navigate to='/access-denied' replace />;
  }

  return <Navigate to={`/admin/exam-proctors/${initialTab}`} replace />;
}
